import {
  GET_HELP_MENU_ITEMS_REQUEST,
  GET_HELP_MENU_ITEMS_SUCCESS,
  GET_HELP_MENU_ITEMS_FAILURE,
  GET_HELP_MENU_DETAILS_REQUEST,
  GET_HELP_MENU_DETAILS_SUCCESS,
  GET_HELP_MENU_DETAILS_FAILURE,
  GET_HELP_MENU_SUCCESS,
  GET_DEPOSIT_MENU_REQUEST,
  GET_DEPOSIT_MENU_SUCCESS,
  GET_DEPOSIT_MENU_FAILURE,
  GET_CMS_UPDATER_REQUEST,
  GET_CMS_UPDATER_SUCCESS,
  GET_CMS_UPDATER_FAILURE
} from 'Store/constants';

const initialState = {
  isLoading: false,
  error: null,
  helpMenuCategories: {
    data: [],
    isLoading: false,
    error: null
  },
  helpMenu: {
    menu: [],
    details: {},
    isLoading: false,
    error: null
  },
  deposit: {
    menu: {},
    isLoading: false,
    error: null
  },
  updater: {
    data: null,
    isLoading: false,
    error: null
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HELP_MENU_ITEMS_REQUEST:
      return {
        ...state,
        helpMenuCategories: {
          ...state.helpMenuCategories,
          isLoading: true,
          error: null
        }
      };

    case GET_HELP_MENU_ITEMS_SUCCESS:
      return {
        ...state,
        helpMenuCategories: {
          data: action.payload,
          isLoading: false,
          error: null
        }
      };

    case GET_HELP_MENU_ITEMS_FAILURE:
      return {
        ...state,
        helpMenuCategories: {
          ...state.helpMenuCategories,
          isLoading: false,
          error: action.payload
        }
      };

    case GET_CMS_UPDATER_REQUEST:
      return {
        ...state,
        updater: {
          ...state.updater,
          isLoading: true,
          error: null
        }
      };
  
    case GET_CMS_UPDATER_SUCCESS:
      return {
        ...state,
        updater: {
          data: action.payload,
          isLoading: false,
          error: null
        }
      };
  
    case GET_CMS_UPDATER_FAILURE:
      return {
        ...state,
        updater: {
          data: action.payload,
          isLoading: false,
          error: action.payload
        }
      };
    
    case GET_HELP_MENU_DETAILS_REQUEST:
      return {
        ...state,
        helpMenu: {
          ...state.helpMenu,
          isLoading: true,
          error: null
        }
      };

    case GET_HELP_MENU_DETAILS_SUCCESS: {
      const { data, categoryName } = action.payload;

      return {
        ...state,
        helpMenu: {
          ...state.helpMenu,
          details: {
            ...state.helpMenu.details,
            [categoryName]: data
          },
          isLoading: false,
          error: null
        }
      };
    }


    case GET_HELP_MENU_SUCCESS:
      return {
        ...state,
        helpMenu: {
          ...state.helpMenu,
          menu: action.payload.helpTopics,
          details: {
            ...state.helpMenu.details,
            ...action.payload.menuDetails
          },
          isLoading: false,
          error: null
        }
      };

    case GET_HELP_MENU_DETAILS_FAILURE:
      return {
        ...state,
        helpMenu: {
          ...state.helpMenuDetails,
          isLoading: false,
          error: action.payload
        }
      };

    case GET_DEPOSIT_MENU_REQUEST:
      return {
        ...state,
        deposit: {
          ...state.deposit,
          isLoading: true,
          error: null
        }
      };
    
    case GET_DEPOSIT_MENU_SUCCESS:
      return {
        ...state,
        deposit: {
          menu: action.payload,
          isLoading: false,
          error: null
        }
      };

    case GET_DEPOSIT_MENU_FAILURE:
      return {
        ...state,
        deposit: {
          ...state.deposit,
          isLoading: false,
          error: action.payload
        }
      };

    default:
      return state;
  }
};
